module.exports = __webpack_public_path__ + "static/media/mar-del-plata.50ae5496.svg";